import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import ProfileCard from './ProfileCard';
import TileGrid from './TileGrid';

const LandingPage = () => {
  const location = useLocation();
  const fromDetail = location.state && location.state.fromDetail;

  const [zoomProgress, setZoomProgress] = useState(fromDetail ? 1 : 0);
  const [showTiles, setShowTiles] = useState(fromDetail ? true : false);

  useEffect(() => {
    const handleWheel = (e) => {
      e.preventDefault();
      
      const delta = e.deltaY;
      setZoomProgress(prev => {
        const newProgress = Math.max(0, Math.min(1, prev + (delta * 0.001)));
        
        // Show tiles when zoom progress reaches 0.3
        if (newProgress > 0.3) {
          setShowTiles(true);
        } else {
          setShowTiles(false);
        }
        
        return newProgress;
      });
    };

    // Prevent default scrolling
    document.body.style.overflow = 'hidden';
    window.addEventListener('wheel', handleWheel, { passive: false });
    
    return () => {
      document.body.style.overflow = 'unset';
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  // Calculate zoom scale and opacity based on zoom progress
  const zoomScale = Math.max(0.1, 1 - zoomProgress);
  const profileOpacity = Math.max(0, 1 - (zoomProgress * 2));
  const tilesProgress = Math.max(0, (zoomProgress - 0.3) / 0.7);

  return (
    <div className="h-screen bg-page-bg overflow-hidden relative">
      {/* Profile card with zoom out effect */}
      <div className="absolute inset-0 flex items-center justify-center px-4">
        <motion.div
          style={{
            scale: zoomScale,
            opacity: profileOpacity,
            transformOrigin: "center center"
          }}
          transition={{ duration: 0.1 }}
        >
          <ProfileCard isVisible={true} />
        </motion.div>
      </div>

      {/* Tiles grid with draw-in animation */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-7xl mx-auto px-4">
          <TileGrid isVisible={showTiles} scrollProgress={tilesProgress} />
        </div>
      </div>
    </div>
  );
};

export default LandingPage;